export const generateAuthorizationToken = ({ accessKey, shortName }) => {
    try {
        return `Key ${btoa(`${shortName}:${atob(accessKey)}`)}`
    } catch (error) {
        // console.error(error)
        return ""
    }
}

export const getValueByPath = (object, path) => {
    if (!object)
        return null

    const keys = path.split('.');
    let value = object;

    for (const key of keys) {
        if (value && typeof value === 'object' && key in value) {
            value = value[key];
        } else {
            return null;
        }
    }

    return value;
}

export const replaceVariables = (template, variables) => {
    let type = typeof template

    if (type == "object")
        template = JSON.stringify(type)

    const regex = /{{(.*?)}}/g;

    const replacedString = template.replace(regex, (match, variable) => {
        const trimmedVariable = variable.trim();
        return variables.hasOwnProperty(trimmedVariable) ? variables[trimmedVariable] : match;
    });

    let result = type == "object" ? JSON.parse(replacedString) : replacedString

    return result
}

export const convertSecondsToMinutesSeconds = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = +(seconds % 60).toFixed(0);

    // Format minutes and seconds with two digits
    const formattedMinutes = minutes.toString().padStart(2, '0');
    const formattedSeconds = remainingSeconds.toString().padStart(2, '0');

    return `${formattedMinutes}:${formattedSeconds}`;
}

export const getEmojiFromValues = (emoji) => {
    if (
        !emoji ||
        !Array.isArray(emoji) ||
        emoji.length === 0
    ) {
        return '';
    }

    try {
        return String.fromCodePoint(...emoji);
    } catch (err) {
        return '';
    }
}